import { render, staticRenderFns } from "./AuctionsShopTab.vue?vue&type=template&id=d7f116f2"
import script from "./AuctionsShopTab.vue?vue&type=script&lang=js"
export * from "./AuctionsShopTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports